import {initialState as initialAreaCoverageState} from '../reducers/area-coverage.js';
import {initialState as initialCompareState} from '../reducers/compare.js';
import {initialState as initialFiltersState} from '../reducers/item-filters.js';
import {initialState as initialItemTypesState} from '../reducers/item-types.js';
import {initialState as initialMapState} from '../reducers/map.js';
import {initialState as initialMosaicsState} from '../reducers/mosaics.js';
import {initialState as initialSearchState} from '../reducers/search.js';
import {DEFAULT_OVERLAYS, UI_MODES} from '@explorer/constants';
import {
  deserializeCenter,
  deserializeCompareSubjects,
  deserializeGeometry,
  serializeCenter,
  serializeGeometry,
  serializeZoom,
} from '@explorer/util/hash';

const filtersConfig = Object.keys(initialFiltersState).reduce(
  (config, filterKey) => {
    config[filterKey] = {
      default: initialFiltersState[filterKey],
      serialize: values => (values ? values.toString() : values),
      deserialize: string => (string ? string.split(',') : null),
    };
    return config;
  },
  {}
);

const config = {
  ...filtersConfig,
  'compare-method': initialCompareState.method,
  mode: UI_MODES.BROWSE,
  folder: '',
  mosaic: '',
  process: '',
  interval: initialMosaicsState.interval,

  'area-coverage': {
    default: initialAreaCoverageState,
    serialize: range => range.join(','),
    deserialize: string => string.split(',').map(Number),
  },
  types: {
    default: Object.keys(initialItemTypesState.selected).filter(
      itemType => initialItemTypesState.selected[itemType]
    ),
    serialize: function (itemTypes) {
      return itemTypes.map(encodeURIComponent).join(',');
    },
    deserialize: function (str) {
      return str.split(',').filter(Boolean).map(decodeURIComponent);
    },
  },

  center: {
    default: initialMapState.center,
    serialize: serializeCenter,
    deserialize: deserializeCenter,
  },
  zoom: {
    default: initialMapState.zoom,
    serialize: serializeZoom,
    deserialize: parseFloat,
  },

  ov: {
    default: DEFAULT_OVERLAYS,
    serialize: overlays => {
      const overlayHash = [];
      for (const overlayName in overlays) {
        if (overlays[overlayName] !== DEFAULT_OVERLAYS[overlayName]) {
          overlayHash.push(
            `${overlayName}:${overlays[overlayName] ? '1' : '0'}`
          );
        }
      }
      return overlayHash.join('-');
    },
    deserialize: val => {
      const overlays = val.split('-');
      const mixin = {};
      for (let i = 0, ii = overlays.length; i < ii; i++) {
        const [name, on] = overlays[i].split(':');
        mixin[name] = on === '1';
      }

      return {
        ...DEFAULT_OVERLAYS,
        ...mixin,
      };
    },
  },
  dates: {
    default: initialSearchState.dateRanges,
    serialize: ranges =>
      ranges
        .map(
          range =>
            `${new Date(range[0]).toISOString()}..${new Date(
              range[1]
            ).toISOString()}`
        )
        .join(','),
    deserialize: function (str) {
      if (!str) {
        return [];
      }
      return decodeURIComponent(str)
        .split(',')
        .map(range => range.split('..'));
    },
  },
  geometry: {
    default: null,
    serialize: serializeGeometry,
    deserialize: deserializeGeometry,
  },
  items: {
    default: [],
    serialize: function (selected) {
      return Object.keys(selected).map(encodeURIComponent).join(',');
    },
    deserialize: function (str) {
      return str.split(',').filter(Boolean).map(decodeURIComponent);
    },
  },
  centerMarker: {
    default: null,
    serialize: function (showMarker) {
      return showMarker ? 'true' : '';
    },
    deserialize: function (str) {
      return str ? true : null;
    },
  },

  comparing: {
    default: {
      0: null,
      1: null,
    },
    serialize: () => '', // hack to not track in URL
    deserialize: deserializeCompareSubjects,
  },
};

export default config;
